<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-menu-button>
        <ion-icon class="icon-menu" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'MENU.setting' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-horizontal ion-padding-bottom" color="light">
  <!-- <ion-button (click)="goTestPage()" *ngIf="debugMode">
    Test
  </ion-button> -->
  <div class="content-div ion-padding-bottom" *ngIf="currentPrivilege?.['account']?.['setting']">
    <ion-label class="font-14 font-bold">
      {{ 'MODULE.list.account' | translate }}
    </ion-label>
    <ion-card class="ion-no-margin" (click)="goAccountDetailPage()" button>
      <ion-item lines="none" detail>
        <ion-label class="ion-no-margin">
          <ion-text class="font-14 ion-text-wrap" [innerHtml]="'SETTING.account.title' | translate" color="dark"></ion-text>
          <ion-label class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('SETTING.account.msg' | translate)" color="medium"></ion-label>
        </ion-label>
      </ion-item>
    </ion-card>

    <ng-container *ngIf="currentPrivilege?.['guest']?.['view']">
      <ion-label class="font-14 font-bold">
        {{ 'MENU.guest_list' | translate }}
      </ion-label>
      <ion-card class="ion-no-margin" (click)="presentSettingFieldModal('invited_by')" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'GUEST.lbl.invited_by' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'SETTING.guest.msg.invited_by' | translate" color="medium"></ion-label>
          </ion-label>
        </ion-item>
      </ion-card>
      <ion-card class="ion-no-margin" (click)="presentSettingFieldModal('category')" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'LBL.category' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'SETTING.guest.msg.category' | translate" color="medium"></ion-label>
          </ion-label>
        </ion-item>
      </ion-card>
      <ion-card class="ion-no-margin" (click)="presentSettingFieldModal('dietary_req')" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'GUEST.lbl.dietary_req' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'SETTING.guest.msg.dietary_req' | translate" color="medium"></ion-label>
          </ion-label>
        </ion-item>
      </ion-card>
      <ion-card class="ion-no-margin" (click)="presentSettingFieldModal('special_req')" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'GUEST.lbl.special_req' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'SETTING.guest.msg.special_req' | translate" color="medium"></ion-label>
          </ion-label>
        </ion-item>
      </ion-card>
      <ion-card class="ion-no-margin" (click)="presentSettingFieldModal('session')" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'LBL.session' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'SETTING.guest.msg.session' | translate" color="medium"></ion-label>
          </ion-label>
        </ion-item>
      </ion-card>
      <ion-card class="ion-no-margin" (click)="presentSeatingSettingModal()" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'MODULE.action.guest.seating' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'SETTING.seating.msg' | translate" color="medium"></ion-label>
          </ion-label>
        </ion-item>
      </ion-card>
    </ng-container>
    <!-- && visitorMode -->
    <ng-container *ngIf="currentPrivilege?.['guest']?.['qrcode']">
      <ion-label class="font-14 font-bold">
        {{ 'VISITOR.lbl.page' | translate }}
      </ion-label>

      <ion-card class="ion-no-margin" *ngIf="visitorMode">
        <ion-item lines="none">
          <ion-text class="font-14" color="dark" slot="start">
            <ng-container *ngIf="newWebsiteMode">
              {{ replaceEventType('WEBSITE.new_website_mode.on' | translate) }}
            </ng-container>
            <ng-container *ngIf="!newWebsiteMode">
              {{ 'WEBSITE.new_website_mode.off' | translate }}
            </ng-container>
          </ion-text>
          <ion-toggle [(ngModel)]="newWebsiteMode" (ionChange)="updateNewWebsiteMode(newWebsiteMode)" slot="end"></ion-toggle>
        </ion-item>
      </ion-card>

      <ng-container *ngIf="!newWebsiteMode">
        <ion-card class="ion-no-margin" (click)="presentVisitorSettingWizard()" button>
          <ion-item lines="none" detail>
            <ion-label class="ion-no-margin">
              <ion-text class="font-14 ion-text-wrap" [innerHtml]="'VISITOR.wizard.title' | translate" color="dark"></ion-text>
              <ion-label class="font-10 ion-text-wrap" [innerHtml]="'VISITOR.wizard.msg' | translate" color="medium"></ion-label>
            </ion-label>
          </ion-item>
        </ion-card>
  
        <ion-card class="ion-no-margin" (click)="presentVisitorSetting('setting')" button>
          <ion-item lines="none" detail>
            <ion-label class="ion-no-margin">
              <ion-text class="font-14 ion-text-wrap" [innerHtml]="'VISITOR.setting.title' | translate" color="dark"></ion-text>
              <ion-label class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('VISITOR.setting.title_msg' | translate)" color="medium"></ion-label>
            </ion-label>
          </ion-item>
        </ion-card>
      
        <ion-card class="ion-no-margin" (click)="presentVisitorSetting('info')" button>
          <ion-item lines="none" detail>
            <ion-label class="ion-no-margin">
              <ion-text class="font-14 ion-text-wrap" [innerHtml]="'VISITOR.setting.info' | translate" color="dark"></ion-text>
              <ion-label class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('VISITOR.setting.info_msg' | translate)" color="medium"></ion-label>
            </ion-label>
          </ion-item>
        </ion-card>
      
        <ion-card class="ion-no-margin" (click)="presentVisitorSetting('theme')" button>
          <ion-item lines="none" detail>
            <ion-label class="ion-no-margin">
              <ion-text class="font-14 ion-text-wrap" [innerHtml]="'VISITOR.setting.theme' | translate" color="dark"></ion-text>
              <ion-label class="font-10 ion-text-wrap" [innerHtml]="'VISITOR.setting.theme_select' | translate" color="medium"></ion-label>
            </ion-label>
          </ion-item>
        </ion-card>
      </ng-container>
    </ng-container>
    
    <ng-container *ngIf="currentPrivilege?.['checkin']?.['view']">
      <ion-label class="font-14 font-bold">
        {{ 'MENU.checkin' | translate }}
      </ion-label>
      <ion-card class="ion-no-margin" (click)="presentCheckinSettingModal()" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'SETTING.checkin.title' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'SETTING.checkin.msg' | translate" color="medium"></ion-label>
          </ion-label>
          
        </ion-item>
        
      </ion-card>
    </ng-container>

    <ng-container>
      <ion-label class="font-14 font-bold">
        {{ 'EXPORT.title' | translate }}
      </ion-label>

      <ion-card class="ion-no-margin" (click)="presentExportQrcodeModal()" *ngIf="currentPrivilege?.['guest']?.['qrcode']" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'EXPORT.qrcode.title' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'EXPORT.qrcode.intro' | translate" color="medium"></ion-label>
          </ion-label>
          
        </ion-item>
        
      </ion-card>

      <ion-card class="ion-no-margin" (click)="export('guestList')" *ngIf="currentPrivilege?.['guest']?.['edit']" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'EXPORT.guest_list.title' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'EXPORT.guest_list.intro' | translate" color="medium"></ion-label>
          </ion-label>
          
        </ion-item>
        
      </ion-card>

      <ion-card class="ion-no-margin" (click)="export('checkin')" *ngIf="currentPrivilege?.['checkin']?.['checkin']" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'EXPORT.checkin.title' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="'EXPORT.checkin.intro' | translate" color="medium"></ion-label>
          </ion-label>
          
        </ion-item>
        
      </ion-card>

      <ion-card class="ion-no-margin" (click)="export('gift')" *ngIf="currentPrivilege?.['gift']?.['edit']" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'EXPORT.gift.title' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('EXPORT.gift.intro' | translate)" color="medium"></ion-label>
          </ion-label>
          
        </ion-item>
        
      </ion-card>

      <ion-card class="ion-no-margin" (click)="export('fullReport')" *ngIf="currentPrivilege?.['guest']?.['edit'] && currentPrivilege?.['checkin']?.['checkin'] && currentPrivilege?.['gift']?.['edit']" button>
        <ion-item lines="none" detail>
          <ion-label class="ion-no-margin">
            <ion-text class="font-14 ion-text-wrap" [innerHtml]="'EXPORT.full_report.title' | translate" color="dark"></ion-text>
            <ion-label class="font-10 ion-text-wrap" [innerHtml]="replaceEventType('EXPORT.full_report.intro' | translate)" color="medium"></ion-label>
          </ion-label>
          
        </ion-item>
        
      </ion-card>
    </ng-container>
  </div>
</ion-content>
